import * as React from "react";

class ContactusComponent extends React.Component {
  render(): JSX.Element {
    return (
      <div className="single-page">
        <div className="page-title">
          <div className="big-title">Contact us</div>
        </div>
        <div className="contact-us">
          <a href="mailto:support@fikafy.com" target="_top">
            contactus@fikafy.com
          </a>
          <div className="loc">Fikafy (SMC-PVT) Limited, G 7/4, Islamabad, Pakistan.</div>
        </div>
      </div>
    );
  }
}

export default ContactusComponent;



// WEBPACK FOOTER //
// ./src/components/contactus.component.tsx